import MedicationsPage from "./MedicationsPage";

export default MedicationsPage;

export * from "./MedicationsPage";
